import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import styles from "../../Alumni/AlumniPages.module.css";

const API = process.env.REACT_APP_BACKEND_API_URL;

const AlumniAdminDirectory = () => {
  const [filters, setFilters] = useState({ q: "", city: "", employment_status: "", cohort_number: "" });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const search = useCallback(() => {
    setLoading(true);
    axios
      .get(`${API}/api/alumni-admin/directory`, { params: { ...filters, page } })
      .then(({ data }) => setResults(data.results))
      .finally(() => setLoading(false));
  }, [filters, page]);

  useEffect(() => {
    const t = setTimeout(search, 300);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <div>
      <h1 className={styles.heading}>Search Alumni</h1>
      <p className={styles.subheading}>Admin view of the alumni directory.</p>

      <div className={styles.filterBar}>
        <input
          className={styles.input}
          placeholder="Search by name, company, designation"
          value={filters.q}
          onChange={(e) => { setPage(1); setFilters((f) => ({ ...f, q: e.target.value })); }}
        />
        <input
          className={styles.input}
          placeholder="City"
          value={filters.city}
          onChange={(e) => { setPage(1); setFilters((f) => ({ ...f, city: e.target.value })); }}
        />
        <input
          className={styles.input}
          placeholder="Cohort number"
          value={filters.cohort_number}
          onChange={(e) => { setPage(1); setFilters((f) => ({ ...f, cohort_number: e.target.value })); }}
        />
        <select
          className={styles.select}
          value={filters.employment_status}
          onChange={(e) => { setPage(1); setFilters((f) => ({ ...f, employment_status: e.target.value })); }}
        >
          <option value="">All employment statuses</option>
          <option value="EMPLOYED">Employed</option>
          <option value="SELF_EMPLOYED">Self-Employed</option>
          <option value="STUDENT">Studying</option>
          <option value="UNEMPLOYED">Unemployed</option>
        </select>
      </div>

      {loading && <div className={styles.emptyState}>Searching...</div>}
      {!loading && results.length === 0 && <div className={styles.emptyState}>No alumni found.</div>}

      {!loading && results.length > 0 && (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Company / Designation</th>
              <th>Location</th>
              <th>Employment</th>
              <th>Cohort / Batch</th>
            </tr>
          </thead>
          <tbody>
            {results.map((a) => (
              <tr key={a.alumni_id}>
                <td>{a.student_name}</td>
                <td>{[a.designation, a.company_name].filter(Boolean).join(" at ") || "—"}</td>
                <td>{[a.city, a.state, a.country].filter(Boolean).join(", ") || "—"}</td>
                <td>{a.employment_status || "—"}</td>
                <td>{[a.cohort_name, a.batch_name].filter(Boolean).join(" / ") || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
        <button className={styles.button} disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
          Previous
        </button>
        <button className={styles.button} onClick={() => setPage((p) => p + 1)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default AlumniAdminDirectory;
